import { executeRequest, Request } from '@jfs/network'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'

const responseParser = (data: any) => {
  const respData = data
  return respData
}

const generateQr = (req: any, tokens: any) => {
  const request: Request<{}> = {
    config: sitConfig(tokens),
    apiPath: APIEndPoints.GetQRCode,
    method: 'POST',
    cache: false,
    body: req,
  }
  return executeRequest(request).then((data) => {
    if (data?.data?.status === 'SUCCESS') {
      return responseParser(data.data)
    } else {
      throw data
    }
  })
}

export { generateQr }
